import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class UrlInstancesAndShedulesService {

  constructor(private http: HttpClient,
    private configService: ConfigService) { }

  getInstancesAndSchdulesAPI =  "/api/geturlinstschdllst";
  clientMasterOptionsAPI =  "/api/gtclntopts";

  GetUrlInstancesAndSchdules(pagination: any) {
    return this.http.post(this.getInstancesAndSchdulesAPI, pagination);
  }

  GetClientMasterOptions() {
    return this.http.post(this.clientMasterOptionsAPI, null);
  }
}
